import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
 
}



// WEBPACK FOOTER //
// D:/PROJECTS/ANGULAR2_PROJECT/WEB/raspab/src/app/app.component.ts